'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValue = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _container = require('@hixme-ui/container');

var _container2 = _interopRequireDefault(_container);

var _text = require('@hixme-ui/text');

var _text2 = _interopRequireDefault(_text);

var _StyledDollarSign = require('./StyledDollarSign');

var _StyledDollarSign2 = _interopRequireDefault(_StyledDollarSign);

var _StyledDollars = require('./StyledDollars');

var _StyledDollars2 = _interopRequireDefault(_StyledDollars);

var _StyledCents = require('./StyledCents');

var _StyledCents2 = _interopRequireDefault(_StyledCents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getValue = exports.getValue = function getValue(num) {
  return {
    dollars: parseFloat(num).toFixed(2).split('.')[0],
    // Cents don't round up exactly as needed.
    // 0.3950 doesn't round up to 0.40 like it should
    // Math.round will do it correctly
    cents: parseFloat(Math.round(num * 100) / 100).toFixed(2).split('.')[1]
  };
};

// hixme-ui


var Price = function Price(_ref) {
  var label = _ref.label,
      value = _ref.value,
      includeCommas = _ref.includeCommas,
      restProps = (0, _objectWithoutProperties3.default)(_ref, ['label', 'value', 'includeCommas']);

  var getColor = function getColor(val) {
    return val < 0;
  };
  return _react2.default.createElement(
    _container2.default,
    { flex: true, alignStart: true, noPadding: true },
    _react2.default.createElement(
      _container2.default,
      { flex: true, alignCenter: true, flexColumn: true, margin: '5px 0', noPadding: true },
      _react2.default.createElement(
        _container2.default,
        { flex: true, noPadding: true },
        _react2.default.createElement(
          _StyledDollarSign2.default,
          (0, _extends3.default)({ id: 'dollar-sign', blue: getColor(value) }, restProps),
          '$'
        ),
        _react2.default.createElement(
          _StyledDollars2.default,
          (0, _extends3.default)({ id: 'dollars', blue: getColor(value) }, restProps),
          includeCommas ? getValue(value).dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : getValue(value).dollars
        ),
        _react2.default.createElement(
          _StyledCents2.default,
          (0, _extends3.default)({ id: 'cents', blue: getColor(value) }, restProps),
          '.',
          getValue(value).cents
        )
      ),
      label !== '' && _react2.default.createElement(
        _container2.default,
        { margin: '-10px 0 0 0', noPadding: true },
        _react2.default.createElement(
          _text2.default,
          { id: 'label', fontSize: '8pt', light: true },
          label
        )
      )
    )
  );
};

Price.propTypes = {
  value: _propTypes2.default.number.isRequired,
  label: _propTypes2.default.string,
  includeCommas: _propTypes2.default.bool
};

Price.defaultProps = {
  label: '',
  includeCommas: false
};

Price.displayName = 'hui:Price';
Price.huiName = 'Price';

exports.default = Price;
//# sourceMappingURL=Price.js.map


//////////////////
// WEBPACK FOOTER
// ../price/lib/Price.js
// module id = 667
// module chunks = 0